import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2006',
    ecrans: ['00-2'],
    params: ['id',
        '?axe_actif'
    ]
});
